import { OTWindowView } from '../types/OneTrust'
import { isString, isStringArray } from '../generic-types'

export function getActiveOneTrustGroups(): string[] {
  const raw = (window as unknown as OTWindowView).OnetrustActiveGroups
  if (isStringArray(raw)) return raw.map((s) => s.trim()).filter(Boolean)
  if (isString(raw))
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  return []
}
